import { render, staticRenderFns } from "./TfaSection.vue?vue&type=template&id=6160a37c&scoped=true&"
import script from "./TfaSection.vue?vue&type=script&lang=js&"
export * from "./TfaSection.vue?vue&type=script&lang=js&"
import style0 from "./TfaSection.vue?vue&type=style&index=0&id=6160a37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160a37c",
  null
  
)

/* custom blocks */
import block0 from "./TfaSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6160a37c')) {
      api.createRecord('6160a37c', component.options)
    } else {
      api.reload('6160a37c', component.options)
    }
    module.hot.accept("./TfaSection.vue?vue&type=template&id=6160a37c&scoped=true&", function () {
      api.rerender('6160a37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/tfa/TfaSection.vue"
export default component.exports